import React, { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";

export const STATUS_OPTS = [["not_started", "Not Started"], ["in_progress", "In Process"], ["completed", "Completed"], ["not_applicable", "Not Applicable"]];
export const normStatus = (s) => (s === "open" || s === "planned" || !s ? "not_started" : s);
const TONE = { not_started: "text-slate-600", in_progress: "text-sky-700", completed: "text-emerald-700", not_applicable: "text-slate-400", cancelled: "text-slate-400" };

/** The one control that changes a task's completion state (Not Started / In Process / Completed / Not Applicable). */
export function TaskStatusSelect({ task, onChanged, source = "person_tasks", onBlocked }) {
  const [na, setNa] = useState(false);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const cur = normStatus(task.status);
  const send = async (status, why) => {
    setBusy(true);
    try {
      await api.post(`/tasks/${task.id}/set-status`, { status, reason: why, source: source === "person_milestones" ? "person_milestones" : "task_detail" });
      toast.success(`${task.title}: ${STATUS_OPTS.find((o) => o[0] === status)[1]}`); setNa(false); setReason(""); onChanged?.();
    } catch (e) { const m = apiError(e); if (e?.response?.status === 409 && onBlocked) onBlocked(m); else toast.error(m); }
    finally { setBusy(false); }
  };
  if (task.status === "cancelled") return <span className="text-xs text-slate-400" data-testid={`task-status-${task.id}`}>Cancelled</span>;
  return (
    <>
      <Select value={cur} disabled={busy || task.status === "planned"} onValueChange={(v) => { if (v === cur) return; if (v === "not_applicable") setNa(true); else send(v); }}>
        <SelectTrigger className={`h-8 w-36 text-xs font-medium ${TONE[cur]}`} data-testid={`task-status-${task.id}`}><SelectValue /></SelectTrigger>
        <SelectContent className="bg-white">{STATUS_OPTS.map(([k, l]) => <SelectItem key={k} value={k} data-testid={`task-status-opt-${k}`}>{l}</SelectItem>)}</SelectContent>
      </Select>
      <Dialog open={na} onOpenChange={setNa}>
        <DialogContent className="bg-white max-w-md" data-testid="task-na-dialog">
          <DialogHeader><DialogTitle>Mark Not Applicable</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-600">"{task.title}" will leave the active list. The task and its history are kept.</p>
          <Textarea rows={3} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Reason (required)" data-testid="task-na-reason" />
          <DialogFooter><Button variant="outline" onClick={() => setNa(false)}>Cancel</Button>
            <Button disabled={!reason.trim() || busy} onClick={() => send("not_applicable", reason)} className="bg-brand hover:bg-brand-strong" data-testid="task-na-confirm">Mark Not Applicable</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
